<template>
  <div id="app">
    <component :is="layout">
      <router-view class="h-100 content-view"></router-view>
    </component>
  </div>
</template>

<script>
// import "@plugins/fontawesome/web-fonts-with-css/css/fontawesome-all.min.css";
import "@assets/flag-icon-css-master/css/flag-icon.min.css";
import "vue-resize/dist/vue-resize.css";
// import "@assets/minified-css/all.min.css";
import "@assets/minified-css/fontawesome-pro-5.2.0/css/all.min.css";
import "@assets/minified-css/fontawesome-pro-5.2.0/js/all.min.js";
import "quill/dist/quill.core.css"; // import styles
require("@assets/plugins/vue-nestable/vue-nestable.scss");

import 'lazysizes';
// import a plugin
import 'lazysizes/plugins/blur-up/ls.blur-up';
import 'lazysizes/plugins/bgset/ls.bgset';

const Layouts = {
  "layout-blank": () => import(/* webpackChunkName: "layout" */ "./layouts/Blank.vue"),
  "layout-default": () =>import(/* webpackChunkName: "layout" */ "./layouts/Default.vue"),
  "layout-design-iframe": () =>import(/* webpackChunkName: "layout" */ "./layouts/DesignIframe.vue"),
  "layout-design-preview": () => import(/* webpackChunkName: "layout" */ "./layouts/DesignPreview.vue"),
  "layout-component": () => import(/* webpackChunkName: "layout" */ "./layouts/Component.vue"),
  "layout-demo-texteditor": () => import(/* webpackChunkName: "layout" */ "./layouts/DemoTextEditor.vue"),
};

export default {
  name: "App",
  components: {
    ...Layouts,
  },
  computed: {
    layout() {
      return 'layout-' + (this.$route.meta.layout || "default");
    },
  },
};
</script>

<style global lang="scss">
.drop-shadow {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
}
html {
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: transparent;
}

@import "@assets/custom-bootstrap.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";

:root {
  --paragraph: #53585d;
  --font-color: #373e44;
  --place-holder: #999999;
  --manage-tab-text: #a7b5c3;
  --fill-focus: #f4fcff;
  --line: #DEE3E6;
  .txt-paragraph {
    color: var(--paragraph);
  }
}
.clear-min-width {
  min-width: 0;
}
.scrollable-menu {
  max-height: 300px;
  overflow: auto;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 2px;
    height: 8px;
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 3px;
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.75);
  }
}
.btn-outline-dark {
  border-color: #979797;
  &:hover {
    border-color: #979797;
    color: #343a40;
    background-color: var(--light);
  }
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
  supported by Chrome, Edge, Opera and Firefox */
}
.nestable-item,
.nestable-item-copy {
  margin: 0 !important;
}
.nestable-list {
  margin-top: 0 !important;
}
.errors {
  line-height: 1;
  input.form-control {
    border: 1px solid #f7381e;
    &:focus {
      box-shadow: unset !important;
    }
  }
  small {
    font-size: 11px;
    color: red;
  }
  #page-keyword.form-control {
    border: 1px solid #f7381e;
    &:focus {
      box-shadow: unset !important;
    }
  }
  .dropdown .btn {
    border: 1px solid #f7381e;
  }
  .custom-control-input {
    border: 1px solid #f7381e;
    color: #fff !important;
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  .input-group {
    input.form-control {
      border: 1px solid #f7381e;
      border-left: 1px solid #ced4da;
      &:focus {
        box-shadow: unset !important;
      }
    }
    .input-group-prepend {
      .input-group-text {
        border: 1px solid #f7381e;
        border-right: 1px solid #ced4da;
      }
    }
  }
}
.modal-header {
  &.danger {
    color: #a03e3b;
    background-color: #f9edee;
    svg {
      color: #a03e3b;
    }
    svg:hover {
      color: rgba(160, 62, 59, 0.8) !important;
    }
  }
  &.warning {
    color: #a66d2d;
    background-color: #fcf8e3;
    svg {
      color: #a66d2d;
    }
    svg:hover {
      color: rgba(166, 110, 45, 0.8) !important;
    }
  }
}
.b-toaster-slot {
  max-width: 35% !important;
  .toast {
    width: 150% !important;
    max-width: 150% !important;
  }
}

.popover {
  max-width: 500px !important;
  font-size: 14px !important;
}
.b-popover-dark.popover {
  background: #000000 !important;
  border-color: #000000 !important;
  border-radius: 4px !important;
}

.b-popover-dark .popover-body {
  color: #FFFFFF !important;
}

.b-popover-dark.bs-popover-top > .arrow::after {
 border-top-color: #000000 !important;
}
.b-popover-dark.bs-popover-bottom > .arrow::after {
 border-bottom-color: #000000 !important;
}
.b-popover-dark.bs-popover-left > .arrow::after {
 border-left-color: #000000 !important;
}
.b-popover-dark.bs-popover-right > .arrow::after {
 border-right-color: #000000 !important;
}
</style>